import { DateTime } from 'luxon';
import { FCInputDataType } from '../enums';
import { ExternalCalendarEventSummary, Opening, Reservation } from '../types';

//Filter input data for FullCalendar current view
const filterFCInput = (
  viewStart: DateTime,
  viewEnd: DateTime,
  fcInput:
    | Opening[]
    | ExternalCalendarEventSummary[]
    | Reservation[]
    | undefined,
  fcInputType: FCInputDataType
): Opening[] | ExternalCalendarEventSummary[] | Reservation[] => {
  if (fcInput === undefined) return [];
  if (fcInputType === FCInputDataType.reservations) {
    const typedInput = fcInput as Reservation[];
    return typedInput.filter(
      (fci) =>
        DateTime.fromISO(fci.startTime) < viewEnd &&
        DateTime.fromISO(fci.endTime) > viewStart
    );
  }
  if (fcInputType === FCInputDataType.openings) {
    const typedInput = fcInput as Opening[];
    return typedInput.filter(
      (fci) =>
        DateTime.fromISO(fci.startDate) < viewEnd &&
        DateTime.fromISO(fci.endDate) > viewStart
    );
  }
  const typedInput = fcInput as ExternalCalendarEventSummary[];
  return typedInput.filter(
    (fci) =>
      DateTime.fromISO(fci.startDate) < viewEnd &&
      DateTime.fromISO(fci.endDate) > viewStart
  );
};

export default filterFCInput;
